import React, { useMemo } from 'react'
import routesConfig from 'lib/routesConfig'
import { useAppSelector } from 'redux/toolkit/hooks'
import CMLLink from 'components/libs/layout/CMLLink'
import appConfig from 'config/appConfig'
import { Auth } from 'v2/modules/lib'

const CMLLinkSelector = () => {
  const { activePath, accessTokenObject, authDomainPolicies } = useAppSelector(_store => ({
    activePath: _store.app.activePath,
    accessTokenObject: _store.auth.accessTokenObject,
    authDomainPolicies: _store.auth.accessTokenObject?.authDomainPolicies
  }))

  const isEmailLogEnabled = useMemo(() => {
    if (!accessTokenObject?.bccAccountId || !authDomainPolicies) {
      return false
    }
    const auth = Auth(authDomainPolicies)
    return auth.hasEmailProtectionAccess(accessTokenObject.bccAccountId)
  }, [accessTokenObject?.bccAccountId, authDomainPolicies])

  const isEmailLogActive = useMemo(() => activePath.id === routesConfig.EMAIL_LOG?.id, [activePath.id])

  switch (true) {
    case !!accessTokenObject && isEmailLogEnabled && !isEmailLogActive && appConfig.APP.IS_ADMIN: {
      return <CMLLink />
    }
    default: {
      return null
    }
  }
}

export default CMLLinkSelector
